var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1"},[_c('vue-skeleton-loader',{staticClass:"mb-6",attrs:{"width":720,"height":145}}),_vm._l((9),function(n){return _c('vue-skeleton-loader',{key:n,staticClass:"mt-1",attrs:{"width":720,"height":50}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }